// src/utils/deviceId.js

/**
 * Utility to get or create a unique device ID
 * The device ID is stored in localStorage and persists across sessions
 */

export const getDeviceId = () => {
  let deviceId = localStorage.getItem("deviceId");
  if (!deviceId) {
    // Generate a unique ID using crypto.randomUUID if available, otherwise fallback
    if (crypto.randomUUID) {
      deviceId = crypto.randomUUID();
    } else {
      // Fallback UUID v4 generator
      deviceId = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    }
    localStorage.setItem("deviceId", deviceId);
  }
  return deviceId;
};

/**
 * Get the device ID synchronously (will create one if it doesn't exist)
 */
export const getDeviceIdSync = () => {
  let deviceId = localStorage.getItem("deviceId");
  if (!deviceId) {
    if (crypto.randomUUID) {
      deviceId = crypto.randomUUID();
    } else {
      deviceId = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    }
    localStorage.setItem("deviceId", deviceId);
  }
  return deviceId;
};

/**
 * Clear the device ID (useful for testing or logout)
 */
export const clearDeviceId = () => {
  localStorage.removeItem("deviceId");
};